<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">学生技能证书数据子类表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="所属实训室">
          <el-select v-model="formInline.training_room" clearable filterable placeholder="请选择所属实训室">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训设备导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle == '导出中...'"
            @click="handleExportByUrl(Object.assign({}, formInline, { export: 1 }))">{{ exportTitle }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%"
        @selection-change="handleSelectionChange(...arguments, 'id')">
        <!-- <custom-table-column type="selection" width="40">
        </custom-table-column> -->
        <!-- <custom-table-column prop="sxjdbh" label="实训基地编号" width="150">
        </custom-table-column>
        <custom-table-column prop="sxjdmc" label="实训基地名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="ssgldwh" label="所属管理单位号" width="160px">
        </custom-table-column>
        <custom-table-column prop="sxjdjlrq" label="实训基地建立日期" width="180px">
        </custom-table-column>
        <custom-table-column prop="ytdw" label="依托单位" min-width="180px">
        </custom-table-column>
        <custom-table-column prop="syzymc" label="适应专业名称" width="180">
        </custom-table-column>
        <custom-table-column prop="jdhzqy" label="基地合作企业" width="150">
        </custom-table-column>
        <custom-table-column prop="sxjdlbm" label="实训基地类别码" width="150">
        </custom-table-column> -->
        <custom-table-column prop="xh" label="学号" width="180px"></custom-table-column>
        <custom-table-column prop="xsxm" label="学生姓名" width="100px"></custom-table-column>
        <custom-table-column prop="jdjg" label="发证机构" width="180px"></custom-table-column>
        <custom-table-column prop="jddjm" label="证书等级码" width="180px"></custom-table-column>
        <custom-table-column prop="zsbh" label="证书编号" width="180px"></custom-table-column>
        <custom-table-column prop="zsmc" label="证书名称" width="180px"></custom-table-column>
        <custom-table-column prop="fzrq" label="发证日期" width="180px"></custom-table-column>
        <custom-table-column prop="sfzcdzzs" label="是否支持电子证书" width="180px"></custom-table-column>
        <custom-table-column prop="xzdycs" label="下载/打印次数" width="180px"></custom-table-column>
        <custom-table-column prop="sjcjsj" label="数据采集时间" width="180px"></custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row, ['created_at', 'deleted_at', 'training_room_id', 'schoolid'])"
              type="text" size="small">编辑</el-button>
            <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="学号" prop="xh">
          <el-input v-model="ruleForm.xh" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="学生姓名" prop="xsxm">
          <el-input v-model="ruleForm.xsxm" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="发证机构" prop="jdjg">
          <el-input v-model="ruleForm.jdjg" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证书等级码" prop="jddjm">
          <el-input v-model="ruleForm.jddjm" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证书编号" prop="zsbh">
          <el-input v-model="ruleForm.zsbh" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证书名称" prop="zsmc">
          <el-input v-model="ruleForm.zsmc" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="发证日期" prop="fzrq">
          <el-input v-model="ruleForm.fzrq" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="是否支持电子证书" prop="sfzcdzzs">
          <el-input v-model="ruleForm.sfzcdzzs" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="下载/打印次数" prop="xzdycs">
          <el-input v-model="ruleForm.xzdycs" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="数据采集时间" prop="sjcjsj">
          <el-input v-model="ruleForm.sjcjsj" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
// import { mixinImport } from '@/assets/js/mixin/import';
// import { mixinOrgan } from '@/assets/js/mixin/organization';
// import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'equipmentInto',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        // device_name: '',
        // structure_1: '',
        // major: '',
        // training_room: '',
      },
      loading: false,
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      total: 40,
      users: [],
      ruleForm: {
      },
      columns: [
      ],
      rules: {
      },
      action: '',
      downloadUrl: 'template/导入模版.xlsx',
      downloadName: '导入模版.xlsx',
      btnTitle: '导入数据',
      exportUrl: '',
      exportBtnTitle: '导出',
      downloadName: '学生技能证书数据子类表列表.xlsx',
    };
  },
  components: {},
  created() {
    this.action = `${this.baseUrlt}api/device/import`;
    this.exportUrl = `${this.baseUrlt}api/sxexport/xsjnds/list`;
  },
  mounted() {
    // this.$store.dispatch('getTarinMent');
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/sxexport/xsjnds/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/sxexport/xsjnds/list', 'get', params);
      if (res.code == 0) {
        if (res.data) {
          this.columns = res.data.columns;
          // this.tableData = [{ZJSJWYXBS:111,XXDM:222}];
          this.tableData = res.data.data;
          this.total = res.data.total;

        }
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
